import { render, staticRenderFns } from "./TileCombination.vue?vue&type=template&id=5fc7d097&scoped=true&"
import script from "./TileCombination.vue?vue&type=script&lang=js&"
export * from "./TileCombination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc7d097",
  null
  
)

export default component.exports